export const TEACHING_PROTOCOL = 'deterministic-v2';
export interface CompletionProof {
  studentCourseStepId?: string | number;
  stepVisitId?: number;
  attemptId?: string;
  protocolVersion?: string;
  flowId?: string;
  reason?: string;
  helper?: boolean;
  verificationAttemptId?: string;
}
export function matchesCompletion(proof: CompletionProof | undefined, step: number | null, visit: number | undefined, attempt: string | undefined): boolean {
  return !!proof && !!step && !!attempt && !proof.helper &&
    Number(proof.studentCourseStepId) === step && proof.stepVisitId === visit &&
    proof.attemptId === attempt && proof.protocolVersion === TEACHING_PROTOCOL;
}

export function hasCurrentPass(proof: CompletionProof | undefined, latest: { id: string; outcome: string } | null): boolean {
  if (!latest && !proof?.verificationAttemptId) return true; // Authored, ungraded terminal.
  return !!latest && latest.outcome === 'passed' && latest.id === proof?.verificationAttemptId;
}
